import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  viewChild,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { Icon } from '../../shared/ui/icon';
@Component({
  selector: 'app-site-unavailable',
  imports: [Icon, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="bg-base-100 text-base-content flex min-h-dvh flex-col px-5 pt-[max(1.5rem,env(safe-area-inset-top,0px))] pb-[max(1.5rem,env(safe-area-inset-bottom,0px))]"
    >
      <main class="m-auto flex w-full max-w-md flex-col items-center text-center">
        <span
          class="bg-base-200 text-base-content grid size-16 place-items-center rounded-2xl"
          aria-hidden="true"
        >
          <app-icon name="alert" class="size-8" />
        </span>

        <!-- role="alert": экран появляется вне навигации, иначе смена содержимого пройдёт молча. -->
        <div role="alert">
          <h1 #heading tabindex="-1" class="mt-5 text-xl font-bold">
            {{ 'SITE.TITLE' | translate }}
          </h1>
          <p class="text-base-content/70 mt-2 text-sm">{{ 'SITE.HINT' | translate }}</p>
        </div>
      </main>
    </div>
  `,
})
export class SiteUnavailable {
  private readonly heading = viewChild.required<ElementRef<HTMLHeadingElement>>('heading');

  constructor() {
    // Роутер не навигировал, значит useRouteFocus() тут не сработает — фокус переносим сами.
    afterNextRender({
      write: () => this.heading().nativeElement.focus({ preventScroll: true }),
    });
  }
}
